/**
 * 选中框层：为选中的非线条元素绘制矩形边框，线条不显示矩形框。
 */
import type { Element } from '@/components/canvas/document/publicTypes';
import {
  SelectionChromeFrame,
  selectionChromeFrameAroundElement,
} from './SelectionChromeFrame';

export interface SelectionBoxLayerProps {
  /** 当前选中的元素（仅非 line 类型会绘制框） */
  elements: Element[];
  /** 拖拽偏移，用于拖拽中框的临时位移 */
  dragOffset: { dx: number; dy: number };
  zoom: number;
}

export function SelectionBoxLayer({ elements, dragOffset, zoom }: SelectionBoxLayerProps) {
  return (
    <div className="absolute inset-0 pointer-events-none z-[2]" aria-hidden>
      {elements.map((el) => {
        const frame = selectionChromeFrameAroundElement(el.layout, el.size, dragOffset, zoom);
        return (
          <SelectionChromeFrame
            key={el.id}
            left={frame.left}
            top={frame.top}
            width={frame.width}
            height={frame.height}
            zoom={zoom}
            rotation={frame.rotation}
          />
        );
      })}
    </div>
  );
}
